/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_PuzzlesInputs */

const en_control_tools_puzzles = /** @type {(inputs: Control_Tools_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes, machine patterns and object sequences, at a glance.`)
};

const zh_control_tools_puzzles = /** @type {(inputs: Control_Tools_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直接查看 Secret Hideout 密码、顺序和操作方法。`)
};

/**
* | output |
* | --- |
* | "Codes, machine patterns and object sequences, at a glance." |
*
* @param {Control_Tools_PuzzlesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_puzzles = /** @type {((inputs?: Control_Tools_PuzzlesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_PuzzlesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_puzzles(inputs)
	return zh_control_tools_puzzles(inputs)
});
export { control_tools_puzzles as "control.tools.puzzles" }